<template>
  <div class="summaryContainer">
    <!-- 切换卡 -->

    <h2>{{ titleVal }}</h2>
    <a-tabs type="card" tab-position="bottom" @change="selectedExcel">
      <a-tab-pane key="汇总日报" tab="汇总日报">
        <!-- 汇总日报 -->
        <table cellspacing="0" cellpadding="10">
          <thead>
            <tr class="firstHead">
              <th
                class="fixedStyle"
                :style="{
                  left: item.isWdithMax ? i * 60 + 60 + 'px' : i * 60 + 'px',
                  width: item.txt == '项目名称' ? '120px' : '60px'
                }"
                rowspan="2"
                v-for="(item, i) in thList"
                :key="i"
              >
                {{ item.txt }}
              </th>
              <th
                class="fixedStyle boxShadow"
                :style="{
                  width: '150px',
                  left: thList.length * 60 + 60 + 'px'
                }"
                colspan="3"
                scope="“col”"
              >
                12月总计
              </th>
              <th colspan="3">2020-12-01</th>
              <th colspan="3">2020-12-02</th>
              <th colspan="3">2020-12-03</th>
            </tr>
            <tr class="twoHead">
              <th
                class="fixedStyle"
                scope="“col”"
                :style="{ left: thList.length * 60 + 60 + 'px' }"
              >
                到面
              </th>
              <th
                class="fixedStyle"
                scope="“col”"
                :style="{ left: thList.length * 60 + 110 + 'px' }"
              >
                入职
              </th>
              <th
                class="fixedStyle boxShadow"
                scope="“col”"
                :style="{ left: thList.length * 60 + 160 + 'px' }"
              >
                离职
              </th>
              <th>到面</th>
              <th>入职</th>
              <th>离职</th>
              <th>到面</th>
              <th>入职</th>
              <th>离职</th>
              <th>到面</th>
              <th>入职</th>
              <th>离职</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="fixedStyle"
                :style="{
                  left: item.isWdithMax ? k * 60 + 60 + 'px' : k * 60 + 'px',
                  width: item.txt == '项目名称' ? '120px' : '60px'
                }"
                v-for="(item, k) in thList"
                :key="k"
              >
                0
              </td>
              <td
                class="fixedStyle"
                :style="{ left: thList.length * 60 + 60 + 'px' }"
              >
                2
              </td>
              <td
                class="fixedStyle"
                :style="{ left: thList.length * 60 + 110 + 'px' }"
              >
                1
              </td>
              <td
                class="fixedStyle"
                :style="{ left: thList.length * 60 + 160 + 'px' }"
              >
                3
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <!-- 汇总日报  end-->
      </a-tab-pane>
      <!-- 东北 -->
      <a-tab-pane key="东北" tab="东北">
        <table cellspacing="0" cellpadding="10">
          <thead>
            <tr class="firstHead">
              <th
                class="fixedStyle"
                :style="{
                  left: item.isWdithMax ? i * 60 + 60 + 'px' : i * 60 + 'px',
                  width: item.txt == '项目名称' ? '120px' : '60px'
                }"
                rowspan="2"
                v-for="(item, i) in thList"
                :key="i"
              >
                {{ item.txt }}
              </th>
              <th
                class="fixedStyle boxShadow"
                :style="{
                  width: '150px',
                  left: thList.length * 60 + 60 + 'px'
                }"
                colspan="3"
                scope="“col”"
              >
                12月总计
              </th>
              <th colspan="3">2020-12-01</th>
              <th colspan="3">2020-12-02</th>
              <th colspan="3">2020-12-03</th>
            </tr>
            <tr class="twoHead">
              <th
                class="fixedStyle"
                scope="“col”"
                :style="{ left: thList.length * 60 + 60 + 'px' }"
              >
                到面
              </th>
              <th
                class="fixedStyle"
                scope="“col”"
                :style="{ left: thList.length * 60 + 110 + 'px' }"
              >
                入职
              </th>
              <th
                class="fixedStyle boxShadow"
                scope="“col”"
                :style="{ left: thList.length * 60 + 160 + 'px' }"
              >
                离职
              </th>
              <th>到面</th>
              <th>入职</th>
              <th>离职</th>
              <th>到面</th>
              <th>入职</th>
              <th>离职</th>
              <th>到面</th>
              <th>入职</th>
              <th>离职</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="fixedStyle"
                :style="{
                  left: item.isWdithMax ? k * 60 + 60 + 'px' : k * 60 + 'px',
                  width: item.txt == '项目名称' ? '120px' : '60px'
                }"
                v-for="(item, k) in thList"
                :key="k"
              >
                0
              </td>
              <td
                class="fixedStyle"
                :style="{ left: thList.length * 60 + 60 + 'px' }"
              >
                2
              </td>
              <td
                class="fixedStyle"
                :style="{ left: thList.length * 60 + 110 + 'px' }"
              >
                1
              </td>
              <td
                class="fixedStyle"
                :style="{ left: thList.length * 60 + 160 + 'px' }"
              >
                3
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </a-tab-pane>
      <!-- 东北 -->
      <!-- 西北 -->
      <a-tab-pane key="西北井江鹏" tab="西北井江鹏"></a-tab-pane>
      <!-- 西北  end-->
      <!-- 华东 -->
      <a-tab-pane key="华东张伟" tab="华东张伟"></a-tab-pane>
      <!-- 华东 end -->
      <!-- 西南 -->
      <a-tab-pane key="西南黄伟伟" tab="西南黄伟伟"></a-tab-pane>
      <!-- 西南 end -->
      <!-- 城市花名册 -->
      <a-tab-pane key="城市花名册" tab="城市花名册"></a-tab-pane>
      <!-- 城市花名册 end -->
      <!-- 费用明细 -->
      <a-tab-pane key="费用明细" tab="费用明细"></a-tab-pane>
      <!-- 费用明细 end -->
    </a-tabs>
    <!-- 切换卡 end -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      thList: [
        {
          txt: "负责人",
          isWdithMax: false,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "项目名称",
          isWdithMax: false,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "岗位",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "甲方结算",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "员工结算",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "服务费(去税）",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "本月招聘支出",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "管理人力成本",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "其他费用(报销、物料等)",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "城市管理费",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "大区管理费",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "利润合计",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "利润率",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "在职",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "仓占比",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        },
        {
          txt: "总仓人数",
          isWdithMax: true,
          isFixed: true,
          isChildren: false
        }
      ],
      titleVal: "汇总日报"
    };
  },
  methods: {
    selectedExcel(activeKey) {
      //   console.log(activeKey);
      this.titleVal = activeKey;
    }
  }
};
</script>
<style lang="less" scoped>
.summaryContainer {
  margin: 30px 2%;
  h2 {
    text-align: center;
    font-size: 16px;
    line-height: 30px;
  }
  table {
    table-layout: fixed;
    width: 96vw;
    overflow-x: scroll;
    border-collapse: separate;
    padding-bottom: 30px;
    // border: 1px solid #333;
    th {
      background: #acdc7e;
    }
    td {
      background: #f7b64b;
    }
    th,
    td {
      text-align: center;
      vertical-align: middle;
      width: 150px;
      border: 1px solid #666;
      padding: 8px 6px;
      //   background-clip: padding-box;
    }
    tr .fixedStyle {
      width: 60px;
      position: sticky;
      z-index: 1;
      left: 0;
    }
    // .boxShadow {
    //   box-shadow: 1px 0 10px 0 rgba(0, 0, 0, 0.5);
    // }
  }
}
</style>
<style lang="less">
.summaryContainer {
  .ant-tabs {
    height: 88vh;
  }
  .ant-tabs-bottom .ant-tabs-bottom-bar {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .ant-tabs-tabpane {
    overflow: auto;
  }
}
</style>
